import { mockComponentRenderProp } from 'bloko/common/setupMockComponents';

const { MenuPlacement, MenuLayer, MenuItem } = jest.requireActual('bloko/blocks/drop/Menu/Click.js');
export { MenuPlacement, MenuLayer, MenuItem };

export default mockComponentRenderProp('DropMenuClick', null, {
    withChildren: true,
    renderArguments: [() => {}],
});
